import { systemColors } from './_system/systemColors.js';
import { systemTypography } from './_system/systemTypography.js';


// System
systemColors();
systemTypography();